import _regeneratorRuntime from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import dayjs from 'dayjs';
export default {
  name: 'groupbuy_activity_order',
  components: {
    groupbuyActivitySel: function groupbuyActivitySel() {
      return import('@/views/group_buy/components/activity_sel_page.vue');
    },
    groupbuyActivityOrderSel: function groupbuyActivityOrderSel() {
      return import('@/views/group_buy/components/activity_order_sel_page.vue');
    },
    groupbuyActivityMoveOrderSel: function groupbuyActivityMoveOrderSel() {
      return import('@/views/group_buy/components/activity_order_sel_page.vue');
    }
  },
  data: function data() {
    return {
      dayjs: dayjs,
      pageConfig: {
        editPageName: '报名管理',
        addFunName: 'groupBuyActivityOrderaddVirtualOrder',
        modifyFunName: 'groupBuyActivityOrderModifySignInfo',
        delFunName: 'groupBuyActivityOrderDel',
        queryFunName: 'groupBuyActivityOrderQuery',
        detailFunName: 'groupBuyActivityOrderDetail',
        msgQueueClearFunName: 'groupBuyActivityOrderMsgQueueClear',
        successFunName: 'groupBuyActivityOrderSuccess',
        upgradeFunName: 'groupBuyActivityOrderUpgrade',
        demotionFunName: 'groupBuyActivityOrderDemotion',
        aloneFunName: 'groupBuyActivityOrderAlone',
        moveFunName: 'groupBuyActivityOrderMove',
        useFunName: 'groupBuyActivityOrderUse',
        refundFunName: 'groupBuyActivityOrderRefund',
        activityDetailFunName: 'groupBuyActivityDetail'
      },
      searchForm: {
        page: 1,
        limit: 10,
        searchKey: null,
        virtualOrder: null,
        inviterUserNickname: null,
        activityName: null,
        activityOrgName: null,
        groupCaptainState: null,
        groupCaptainNickname: null,
        state: 'pay',
        useState: null,
        refundState: null,
        settlementState: null,
        starDate: '',
        endDate: '',
        sortField: 'create_time'
      },
      virtualData: {
        virtualOrder: true,
        activityId: null,
        activityName: null,
        orderFinalCost: null,
        groupId: null,
        groupCaptainNickname: null,
        userNickname: null,
        userImage: null
      },
      formData: {
        id: null,
        virtualOrder: null,
        inviterUserId: null,
        inviterUserNickname: null,
        inviterUserImage: null,
        userId: null,
        userNickname: null,
        userImage: null,
        userOpenid: null,
        activityId: null,
        activityName: null,
        activityListImage: null,
        activityOriginalCost: null,
        activityAdvanceCost: null,
        activityOrgName: null,
        activityOrgLogo: null,
        activityUserId: null,
        activityCompanyId: null,
        groupId: null,
        groupCaptainState: null,
        groupCaptainNickname: null,
        groupCaptainImage: null,
        groupPersonAmount: null,
        name: null,
        phone: null,
        age: null,
        courseFirst: null,
        courseFirstArray: [],
        courseSecond: null,
        courseSecondArray: [],
        courseThird: null,
        courseThirdArray: [],
        courseFourth: null,
        courseFourthArray: [],
        courseFifth: null,
        courseFifthArray: [],
        orderFinalCost: null,
        payCategory: null,
        payType: null,
        state: null,
        payTime: null,
        cancelType: null,
        cancelTime: null,
        useState: null,
        useCode: null,
        refundUseState: null,
        refundState: null,
        refundTime: null,
        settlementState: null,
        settlementTime: null
      },
      detailData: {
        id: null,
        virtualOrder: null,
        inviterUserId: null,
        inviterUserNickname: null,
        inviterUserImage: null,
        userId: null,
        userNickname: null,
        userImage: null,
        userOpenid: null,
        activityId: null,
        activityName: null,
        activityListImage: null,
        activityOriginalCost: null,
        activityAdvanceCost: null,
        activityOrgName: null,
        activityOrgLogo: null,
        activityUserId: null,
        activityCompanyId: null,
        groupId: null,
        groupCaptainState: null,
        groupCaptainNickname: null,
        groupCaptainImage: null,
        groupPersonAmount: null,
        name: null,
        phone: null,
        age: null,
        courseFirst: null,
        courseSecond: null,
        courseThird: null,
        courseFourth: null,
        courseFifth: null,
        orderFinalCost: null,
        payCategory: null,
        payType: null,
        state: null,
        payTime: null,
        cancelType: null,
        cancelTime: null,
        useState: null,
        useCode: null,
        refundUseState: null,
        refundState: null,
        refundTime: null,
        settlementState: null,
        settlementTime: null,
        refundShow: false
      },
      groupData: {
        id: null,
        activityId: null,
        activityName: null,
        currentGroupId: null,
        currentGroupCaptainNickname: null,
        newGroupId: null,
        newGroupCaptainNickname: null
      },
      rules: {
        name: [{
          required: true,
          message: '报名姓名不能为空',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          message: '报名电话不能为空',
          trigger: 'blur'
        }]
      },
      virtualRules: {
        activityId: [{
          required: true,
          message: '归属活动不能为空',
          trigger: 'blur'
        }],
        userNickname: [{
          required: true,
          message: '用户昵称不能为空',
          trigger: 'blur'
        }],
        userImage: [{
          required: true,
          message: '用户头像不能为空',
          trigger: 'blur'
        }]
      },
      groupRules: {
        newGroupId: [{
          required: true,
          message: '目标团不能为空',
          trigger: 'blur'
        }]
      },
      activitySelData: {
        isShow: false
      },
      activityOrderSelData: {
        isShow: false
      },
      activityOrderChangeSelData: {
        isShow: false
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      groupDialogShow: false,
      detailDialogShow: false,
      virtualDialogShow: false,
      editDialogTitle: '',
      formLabelWidth: '100px',
      emptyFormData: {},
      emptyGroupData: {},
      emptyDetailData: {},
      emptyVirtualData: {}
    };
  },
  mounted: function mounted() {
    this.emptyFormData = JSON.parse(JSON.stringify(this.formData));
    this.emptyGroupData = JSON.parse(JSON.stringify(this.groupData));
    this.emptyDetailData = JSON.parse(JSON.stringify(this.detailData));
    this.emptyVirtualData = JSON.parse(JSON.stringify(this.virtualData));
    this.query();
  },
  methods: {
    beforeCommand: function beforeCommand(index, row, command) {
      return {
        index: index,
        row: row,
        command: command
      };
    },
    moreButton: function moreButton(command) {
      switch (command.command) {
        case 'edit':
          this.edit(command.row);
          break;
        case 'alone':
          this.alone(command.row);
          break;
        case 'upgrade':
          this.upgrade(command.row);
          break;
        case 'demotion':
          this.demotion(command.row);
          break;
        case 'move':
          this.move(command.row);
          break;
        case 'use':
          this.use(command.row);
          break;
        case 'refund':
          this.refund(command.row);
          break;
        case 'del':
          this.del(command.row);
          break;
      }
    },
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      this.formData = paramData;
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    initGroupData: function initGroupData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      this.groupData = paramData;
      if (typeof this.$refs['groupDataVerify'] !== 'undefined') {
        this.$refs['groupDataVerify'].clearValidate();
      }
    },
    initVirtualData: function initVirtualData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      this.virtualData = paramData;
      if (typeof this.$refs['virtualDataVerify'] !== 'undefined') {
        this.$refs['virtualDataVerify'].clearValidate();
      }
    },
    initDetailData: function initDetailData(data) {
      // 处理 “后端” > “前端” 数据差异
      var paramData = JSON.parse(JSON.stringify(data));
      this.detailData = paramData;
      this.detailData.refundShow = false;
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      return saveFormData;
    },
    saveVirtualDataProcess: function saveVirtualDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      return saveFormData;
    },
    beforeFileUpload: function beforeFileUpload(file) {
      var isImage = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
      if (!isImage) {
        this.$message.error('文件必须是图片格式');
      }
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('图片大小不超过5M！');
      }
      return isImage && isLt5M;
    },
    uploadVirtualDataUserImage: function uploadVirtualDataUserImage(_ref) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var file;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              file = _ref.file;
              _this.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return _this.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        _this.virtualData.userImage = _context.sent;
                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    removeVirtualDataUserImage: function removeVirtualDataUserImage() {
      this.virtualData.userImage = '';
    },
    add: function add() {
      this.virtualDialogShow = true;
    },
    activitySel: function activitySel(data) {
      if (data) {
        this.virtualData.activityId = data.id;
        this.virtualData.activityName = data.name;
        this.virtualData.orderFinalCost = data.advanceCost;
      }
      this.activitySelData.isShow = false;
    },
    activityOrderSel: function activityOrderSel(data) {
      if (data) {
        this.virtualData.groupId = data.groupId;
        this.virtualData.groupCaptainNickname = data.userNickname;
      }
      this.activityOrderSelData.isShow = false;
    },
    activityMoveOrderSel: function activityMoveOrderSel(data) {
      if (data) {
        this.groupData.newGroupId = data.groupId;
        this.groupData.newGroupCaptainNickname = data.userNickname;
      }
      this.activityOrderChangeSelData.isShow = false;
    },
    edit: function edit(rowData) {
      var _this2 = this;
      Promise.all([new Promise(function (resolve, reject) {
        _this2.$api[_this2.pageConfig.detailFunName](rowData.id).then(function (res) {
          resolve(res);
        });
      }), new Promise(function (resolve, reject) {
        _this2.$api[_this2.pageConfig.activityDetailFunName](rowData.activityId).then(function (res) {
          resolve(res);
        });
      })]).then(function (result) {
        _this2.initFormData(result[0].data);
        var activityDetail = result[1].data;
        if (activityDetail.courseFirst) {
          _this2.formData.courseFirstArray = activityDetail.courseFirst.split(',');
        }
        if (activityDetail.courseSecond) {
          _this2.formData.courseSecondArray = activityDetail.courseSecond.split(',');
        }
        if (activityDetail.courseThird) {
          _this2.formData.courseThirdArray = activityDetail.courseThird.split(',');
        }
        if (activityDetail.courseFourth) {
          _this2.formData.courseFourthArray = activityDetail.courseFourth.split(',');
        }
        if (activityDetail.courseFifth) {
          _this2.formData.courseFifthArray = activityDetail.courseFifth.split(',');
        }
        _this2.editDialogTitle = '报名信息维护';
        _this2.editDialogShow = true;
      });
    },
    alone: function alone(rowData) {
      var _this3 = this;
      this.$confirm('确定将' + rowData.userNickname + '独立成团吗').then(function () {
        _this3.$api[_this3.pageConfig.aloneFunName](rowData.id).then(function (res) {
          if (res.data) {
            _this3.$message.success('独立成团成功');
            _this3.query();
          } else {
            _this3.$message.error('独立成团失败');
          }
        });
      });
    },
    upgrade: function upgrade(rowData) {
      var _this4 = this;
      this.$confirm('确定将' + rowData.userNickname + '升为团长吗').then(function () {
        _this4.$api[_this4.pageConfig.upgradeFunName](rowData.id).then(function (res) {
          if (res.data) {
            _this4.$message.success('升为团长成功');
            _this4.query();
          } else {
            _this4.$message.error('升为团长失败');
          }
        });
      });
    },
    demotion: function demotion(rowData) {
      var _this5 = this;
      this.$confirm('确定将' + rowData.userNickname + '降为团员吗').then(function () {
        _this5.$api[_this5.pageConfig.demotionFunName](rowData.id).then(function (res) {
          if (res.data) {
            _this5.$message.success('降为团员成功');
            _this5.query();
          } else {
            _this5.$message.error('降为团员失败');
          }
        });
      });
    },
    move: function move(rowData) {
      this.groupData.id = rowData.id;
      this.groupData.activityId = rowData.activityId;
      this.groupData.activityName = rowData.activityName;
      this.groupData.currentGroupId = rowData.groupId;
      this.groupData.currentGroupCaptainNickname = rowData.groupCaptainNickname;
      this.groupData.newGroupId = null;
      this.groupData.newGroupId = null;
      this.groupDialogShow = true;
    },
    use: function use(rowData) {
      var _this6 = this;
      this.$prompt('请输入核销码', '《' + rowData.userNickname + '》订单核销', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValidator: function inputValidator(value) {
          if (!value) {
            return false;
          }
        },
        inputErrorMessage: '核销码不能为空'
      }).then(function (_ref3) {
        var value = _ref3.value;
        _this6.$api[_this6.pageConfig.useFunName](rowData.id, value).then(function (res) {
          if (res.data) {
            _this6.$message.success('核销成功');
            _this6.query();
          } else {
            _this6.$message.error('核销失败');
          }
        });
      }).catch(function () {});
    },
    refund: function refund(rowData) {
      var _this7 = this;
      this.$api[this.pageConfig.detailFunName](rowData.id).then(function (res) {
        _this7.initDetailData(res.data);
        _this7.detailData.refundShow = true;
        _this7.detailDialogShow = true;
      });
    },
    submitRefund: function submitRefund(id, refundUseState) {
      var _this8 = this;
      this.$confirm('确定要 ' + (refundUseState ? '“退款” 并且 “退款后可核销”' : '“退款” 并且 “退款后不可核销”') + ' 吗').then(function () {
        _this8.$api[_this8.pageConfig.refundFunName](id, refundUseState).then(function (res) {
          if (res.data) {
            _this8.$message.success('退款申请成功');
            _this8.detailData.refundShow = false;
            _this8.detailDialogShow = false;
            _this8.query();
          } else {
            _this8.$message.error('退款申请失败');
          }
        });
      });
    },
    del: function del(rowData) {
      var _this9 = this;
      this.$confirm('确定要删除吗').then(function () {
        _this9.$api[_this9.pageConfig.delFunName](rowData.id).then(function (res) {
          if (res.data) {
            _this9.$message.success('删除成功');
            _this9.query();
          } else {
            _this9.$message.error('删除失败');
          }
        });
      });
    },
    query: function query() {
      var _this10 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this10.tableData = res.data || [];
        _this10.totalCount = res.count;
        _this10.queryLoading = false;
      });
    },
    detail: function detail(rowData) {
      var _this11 = this;
      this.$api[this.pageConfig.detailFunName](rowData.id).then(function (res) {
        _this11.initDetailData(res.data);
        _this11.detailDialogShow = true;
      });
    },
    previewFile: function previewFile(filePath) {
      window.open(filePath);
    },
    submitFormData: function submitFormData() {
      var _this12 = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          _this12.$api[_this12.pageConfig.modifyFunName](_this12.saveFormDataProcess(_this12.formData)).then(function (res) {
            if (res.data) {
              _this12.$message.success('编辑成功');
              _this12.initFormData(_this12.emptyFormData);
              _this12.editDialogShow = false;
              _this12.query();
            } else {
              _this12.$message.error('编辑失败');
            }
          });
        }
      });
    },
    submitGroupData: function submitGroupData() {
      var _this13 = this;
      this.$refs['groupDataVerify'].validate(function (valid) {
        if (valid) {
          _this13.$api[_this13.pageConfig.moveFunName](_this13.groupData.id, _this13.groupData.newGroupId).then(function (res) {
            if (res.data) {
              _this13.$message.success('移团成功');
              _this13.initGroupData(_this13.emptyGroupData);
              _this13.groupDialogShow = false;
              _this13.query();
            } else {
              _this13.$message.error('移团失败');
            }
          });
        }
      });
    },
    submitVirtualData: function submitVirtualData() {
      var _this14 = this;
      this.$refs['virtualDataVerify'].validate(function (valid) {
        if (valid) {
          _this14.$api[_this14.pageConfig.addFunName](_this14.saveVirtualDataProcess(_this14.virtualData)).then(function (res) {
            if (res.data) {
              _this14.$message.success('新增成功');
              _this14.initVirtualData(_this14.emptyVirtualData);
              _this14.virtualDialogShow = false;
              _this14.query();
            } else {
              _this14.$message.error('新增失败');
            }
          });
        }
      });
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
    },
    closeGroupDialogShow: function closeGroupDialogShow() {
      this.groupDialogShow = false;
      this.initGroupData(this.emptyGroupData);
    },
    closeVirtualDialogShow: function closeVirtualDialogShow() {
      this.virtualDialogShow = false;
      this.initVirtualData(this.emptyVirtualData);
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    }
  }
};